class BaseBookmarks {

    constructor() {
        this.key = 'ao-au-bo'; //asteonline auction bookarks
    }

    getValues() {
        const values = localStorage.getItem(this.key);
        if (!values) {
            return [];
        }
        return values.split('|');
    }

    setValues(arr) {
        return localStorage.setItem(this.key, arr.join('|'));
    }

    isBookmarked(uuid) {
        return this.getValues().includes(uuid);
    }

    add(uuid) {
        var values = this.getValues();
        values.push(uuid);
        this.setValues(values);
    }

    remove(uuid) {
        var values = this.getValues();
        const index = values.indexOf(uuid);
        if (index < 0) return;
        values.splice(index, 1);
        if (values.length > 0) {
            this.setValues(values);
        } else {
            localStorage.removeItem(this.key);
        }
    }

    removeMissing(uuids) {
        const values = this.getValues();
        uuids.forEach(uuid => {
            if (!values.includes(uuid)) {
                this.remove(uuid);
            }
        });
    }
}

export default BaseBookmarks;